// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Biux","col":"styles_col__XpW1o"};